export default __webpack_public_path__ + "static/elevator_w.1fbfd81fc4e7ef608214b50b18c41530.png";